<template>
  <div class="c-app" :class="{ 'c-dark-theme': $store.state.darkMode }">
    <!-- <TheSidebar v-if="show_menu"/> -->
    <CWrapper>
      <TheHeader/>
      <div class="c-body">
        <main class="c-main">
          <CContainer fluid>
            <transition name="fade" mode="out-in">
              <router-view :key="$route.path"></router-view>
            </transition>
          </CContainer>
        </main>
      </div>
      <TheFooter/>
    </CWrapper>
    <loading :active="visible" :can-cancel="true"></loading>
    <CToaster placement="top-end">
      <template v-for="(toast, key) in toasts">
        <CToast :color="toast.color" v-bind="toast" :key="'toast' + key" :show="true">
          {{toast.content}}
        </CToast>
      </template>
    </CToaster>
  </div>
</template>
<script>
import TheSidebar from './TheSidebar'
import TheHeader from './TheHeader'
import TheFooter from './TheFooter'
import store from '../store'
import Vue from 'vue';
import Loading from 'vue-loading-overlay/dist/vue-loading.js';
import 'vue-loading-overlay/dist/vue-loading.css';
import ws from '../services/general';

export default {
  name: 'TheContainer',
  components: {
    TheSidebar,
    TheHeader,
    TheFooter,
    Loading
  },
  data() {
      return {
        is_administrator: false,
        is_collaborator: false,
        is_kam: false,
        show_menu: false
      }
  },
  mounted: async function() {
    // let response = await ws.getParameters(); 

    // if(response.type == "success"){
    //   store.commit('parameters', response.data);
    // }

    this.is_administrator = !!localStorage.getItem("is_administrator");
    this.is_collaborator = !!localStorage.getItem("is_collaborator");
    this.is_kam = !!localStorage.getItem("is_kam");

    this.show_menu = localStorage.getItem("show_menu") == "true" ? 1 : 0;
    this.show_menu = false; //Mientras no haya admin siempre será false

    if(!this.is_collaborator){
        localStorage.removeItem("token");
        store.commit('clear');
        router.push("login");
        return;
    }
  }, 
  computed: {
    toasts () {
      return store.state.toasts;
    },
    visible() {
      return store.state.isLoading;
    }
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
